import type { RankingBundlePointer } from "@/types/rankingBundle";

/** Storage root for customer-visible (org-scoped) AI-trait bundles. */
const ORG_SCOPED_RANKING_STORAGE_ROOT = "rankingBundles/";

/**
 * True for an org-scoped ranking-bundle Storage path
 * (`rankingBundles/{orgId}/{taskId}/{bundleId}/...`). Distinct from the super-admin demo prefix
 * `adminRankingBundles/...`. Used to decide whether an asset path must be fetched via `getBlob`.
 */
export function isOrgScopedRankingStoragePath(value: string): boolean {
  return value.startsWith(ORG_SCOPED_RANKING_STORAGE_ROOT);
}

function bundleMillis(createdAt: RankingBundlePointer["createdAt"] | undefined): number {
  return createdAt?.toMillis?.() ?? 0;
}

/**
 * The most recently created `"ready"` bundle pointer for a task, or null if none are ready.
 * Client-side selection (a task has only a handful of bundles) — avoids a composite index.
 */
export function pickLatestReadyBundle(
  pointers: RankingBundlePointer[],
): RankingBundlePointer | null {
  const ready = pointers.filter((pointer) => pointer.status === "ready");
  if (ready.length === 0) return null;
  return ready.reduce((latest, candidate) =>
    bundleMillis(candidate.createdAt) > bundleMillis(latest.createdAt) ? candidate : latest,
  );
}
